import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './config.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./config.service";
export class ContratistasService {
    constructor(http, configService) {
        this.http = http;
        this.configService = configService;
    }
    getContatistas() {
        const userid = sessionStorage.getItem('userid');
        const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('batoken'), User: userid });
        return this.http.get(`${this.configService.API_URL}/contratistas/listacontratistas?user=${userid}`, { headers }).toPromise();
    }
    getContratistaByZona(zona) {
        const userid = sessionStorage.getItem('userid');
        const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('batoken'), User: userid });
        return this.http.get(`${this.configService.API_URL}/contratistas/listacontratistasByZona?zona=${zona}`, { headers }).toPromise();
    }
}
ContratistasService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ContratistasService_Factory() { return new ContratistasService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService)); }, token: ContratistasService, providedIn: "root" });
